export default "__VITE_ASSET__MiTwh3u2__"